function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVerticals = function SvgVerticals(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "14 14 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M26 30v-4h4v4h-4Zm-6 0v-4h4v4h-4Zm-6 0v-4h4v4h-4Zm12-6v-4h4v4h-4Zm-6 0v-4h4v4h-4Zm-6 0v-4h4v4h-4Zm12-6v-4h4v4h-4Zm-6 0v-4h4v4h-4Zm-6 0v-4h4v4h-4Z",
    style: {
      fill: "currentColor"
    }
  }));
};
export default SvgVerticals;